import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import { Footer, Header, TopBanner } from '../../js/components'
import { Testimonials, FaqReferral, FaqAffiliate } from '../../js/components'
import Link from 'next/link'
import Image from 'next/image'
import {
  OrganizationSchema,
  WebPageSchema,
  BreadcrumbListSchema,
  FAQSchema,
} from '../../js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks

export async function getStaticProps({ locale, locales }) {
  const host =
    process.env.NODE_ENV === 'development' ? process.env.LOCALHOST : process.env.CHARMELEON //"http://localhost:8080/"
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'affiliate.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  return {
    props: { content, locale, locales },
  }
}

export default function Affiliate({ content, locale, locales }) {
  const [affiliate, setAffiliate] = useState(false)
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema name={content.head.title} description={content.head.description} />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Affiliate',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}affiliate`,
          },
        ]}
      />
      <FAQSchema faqs={content.faqaffiliate.list} />
      <Head>
        <title>{content.head.title}</title>
        <meta itemProp="name" content={content.head.title} />
        <meta itemProp="description" content={content.head.description} />
        <meta name="description" content={content.head.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        <meta
          itemProp="image"
          content={
            'https://storage.googleapis.com/dratini/blog/small/ReferalandAffiliateProgram1.png'
          }
        />
        <meta
          property="og:image"
          content={
            'https://storage.googleapis.com/dratini/blog/small/ReferalandAffiliateProgram1.png'
          }
        />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}/affiliate`}
          />
        ))}
        <link rel="alternate" href={`https://edworking.com/affiliate`} hrefLang="x-default" />
        <link
          rel="canonical"
          href={`https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}affiliate`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header clean content={content.header} topbanner={true} />
      <IntroCompare content={content.intro} />
      <Selector content={content.selector} affiliate={affiliate} setAffiliate={setAffiliate} />
      <Summary affiliate={affiliate} content={content.summary} />
      {affiliate ? (
        <ExplanationAffiliate content={content.affiliate} />
      ) : (
        <ExplanationReferral content={content.referral} />
      )}
      {affiliate && <Apuntate content={content.apuntate} affiliate={affiliate} />}
      {!affiliate && <Tiers content={content.tiers} />}
      <Marketing content={content.marketing} affiliate={affiliate} />
      <div className="barcolors1" />
      <Testimonials content={content.reviews} />
      {affiliate ? (
        <FaqAffiliate content={content.faqaffiliate} />
      ) : (
        <FaqReferral content={content.faqreferral} />
      )}
      <JoinProgram affiliate={affiliate} content={content.join} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}
const Marketing = ({ affiliate, content }) => {
  return (
    <section
      className="campaign intro"
      style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #F0F6F7)' }}
    >
      <div className="column">
        <h2 className="title" style={{ fontSize: 30, lineHeight: '40px' }}>
          {content.title1}{' '}
          <span className="highlight">{affiliate ? content.title2 : content.title3}</span>{' '}
          {content.title4}
        </h2>
        <h2 className="description" style={{ marginBottom: 20, marginTop: 20 }}>
          {content.description}
        </h2>
        <Link
          href="https://drive.google.com/drive/folders/1V0StdM3wfiWACi4mV3NAj6s7nLG1EODO"
          className="blueButton"
          style={{ width: 200, margin: 'auto' }}
        >
          {content.button}
        </Link>
      </div>
      <div className="column">
        <Image
          width={445}
          height={424}
          className="newway"
          src="/images/main/Allin1.png"
          alt="Front Platform"
        />
      </div>
    </section>
  )
}
const Apuntate = ({ content }) => {
  return (
    <section className="newsletter affiliate">
      <div className="text">
        <div className="newsTitle">
          {content.title1} <span style={{ color: '#FD3F67' }}>{content.title2}</span>{' '}
          {content.title3}
        </div>
        <div className="description">{content.description}</div>
      </div>
    </section>
  )
}
const ExplanationAffiliate = ({ content }) => {
  return (
    <section className="three-columns blue">
      <div className="title">{content.title}</div>
      <div className="explanations">
        <div className="explanation">
          <div className="ico" style={{ color: '#fcb504' }}>
            01
          </div>
          <h2 className="title">{content.explanation[0].title}</h2>
          <h4 className="description">{content.explanation[0].description}</h4>
        </div>
        <div className="explanation">
          <div className="ico" style={{ color: '#fd3f67' }}>
            02
          </div>
          <h2 className="title">{content.explanation[1].title}</h2>
          <h4 className="description">{content.explanation[1].description}</h4>
        </div>
        <div className="explanation">
          <div className="ico" style={{ color: '#05d6a2' }}>
            03
          </div>
          <h2 className="title">{content.explanation[2].title}</h2>
          <h4 className="description">{content.explanation[2].description}</h4>
        </div>
      </div>
    </section>
  )
}
const ExplanationReferral = ({ content }) => {
  return (
    <section className="three-columns blue">
      <div className="title">{content.title}</div>
      <div className="explanations">
        <div className="explanation">
          <div className="ico" style={{ color: '#fcb504' }}>
            01
          </div>
          <h2 className="title">{content.explanation[0].title}</h2>
          <h4 className="description">{content.explanation[0].description}</h4>
        </div>
        <div className="explanation">
          <div className="ico" style={{ color: '#fd3f67' }}>
            02
          </div>
          <h2 className="title">{content.explanation[1].title}</h2>
          <h4 className="description">{content.explanation[1].description}</h4>
        </div>
        <div className="explanation">
          <div className="ico" style={{ color: '#05d6a2' }}>
            03
          </div>
          <h2 className="title">{content.explanation[2].title}</h2>
          <h4 className="description">{content.explanation[2].description}</h4>
        </div>
      </div>
    </section>
  )
}
const Tiers = ({ content }) => {
  return (
    <section className="three-columns">
      <div className="title">{content.title}</div>
      <div className="description" style={{ marginBottom: 40, width: 350 }}>
        {content.description}
      </div>
      <div className="explanations">
        <div className="explanation">
          <div
            className="ico points"
            style={{
              background: '#fcb504A0' /*, border: '3px solid #fcb504'*/,
            }}
          >
            £1
          </div>
          <h2 className="title">{content.explanations[0].title}</h2>
          <h4 className="description">{content.explanations[0].description}</h4>
        </div>
        <div className="explanation">
          <div
            className="ico points"
            style={{
              background: '#fd3f67c0' /*, border: '3px solid #fd3f67'*/,
            }}
          >
            £2
          </div>
          <h2 className="title">{content.explanations[1].title}</h2>
          <h4 className="description">{content.explanations[1].description}</h4>
        </div>
        <div className="explanation">
          <div
            className="ico points"
            style={{
              background: '#05d6a2C0' /*, border: '3px solid #05d6a2'*/,
            }}
          >
            £10
          </div>
          <h2 className="title">{content.explanations[2].title}</h2>
          <h4 className="description">{content.explanations[2].description}</h4>
        </div>
      </div>
    </section>
  )
}
export const JoinProgram = ({ affiliate, content }) => {
  return (
    <section className="tryedworking">
      <Image
        width={750}
        height={222}
        style={{ height: 'auto' }}
        src="/images/BackgroundTryit.png"
        alt="Try Edworking"
      />
      {affiliate ? (
        <span>
          {content.affiliate[0]}{' '}
          <span style={{ color: '#0FC8EF' }}>{content.affiliate[1]}</span>{' '}
          {content.affiliate[2]}
        </span>
      ) : (
        <span>
          {content.referral[0]} <span style={{ color: '#0FC8EF' }}>{content.referral[1]}</span>{' '}
          {content.referral[2]}
        </span>
      )}
      <Link style={{ zIndex: 5 }} href="https://app.edworking.com/signup/user" rel="noopener">
        <div className="blueButton">{content.button}</div>
      </Link>
    </section>
  )
}

const Summary = ({ affiliate, content }) => {
  return (
    <div className="basic">
      {affiliate ? (
        <div className="title">{content.title[0]}</div>
      ) : (
        <div className="title">{content.title[1]}</div>
      )}
      {affiliate ? (
        <div className="description" style={{ width: '60%' }}>
          {content.description[0]}
        </div>
      ) : (
        <div className="description" style={{ width: '60%' }}>
          {content.description[1]}
        </div>
      )}
      {affiliate && (
        <Link className="blueButton" href="/contact" style={{ marginTop: 40 }}>
          {content.button}
        </Link>
      )}
    </div>
  )
}

const Selector = ({ setAffiliate, affiliate, content }) => {
  return (
    <div className="selector affiliate">
      <span id="selector" className={`top`} style={{ left: !affiliate ? 5 : 196 }}></span>
      <div id="monthly" className="tab selected" onClick={() => setAffiliate(false)}>
        <span>{content.referral}</span>
      </div>
      <div id="yearly" className="tab" onClick={() => setAffiliate(true)}>
        <span>{content.affiliate}</span>
      </div>
    </div>
  )
}
const IntroCompare = ({ content }) => {
  return (
    <section className="import intro">
      <div className="column" style={{ width: '40%', zIndex: 2 }}>
        <h1 className="title" style={{ maxWidth: 300 }}>
          {content.title}
        </h1>
        <h2 className="description">{content.description}</h2>
      </div>
      <div className="column" style={{ width: '60%' }}>
        <Image
          style={{ width: '100%', height: 'auto' }}
          width={600}
          height={300}
          className="video"
          src="https://storage.googleapis.com/dratini/blog/small/ReferalandAffiliateProgram2.png"
          alt="Task Management"
        />
      </div>
    </section>
  )
}
